<template>
  <segments-configuration
    :segments.sync="segmentsLocal"
    :error="error"
    :disabled="disabled"
    :description="description"
    :info-content="infoContent"
    :title="title"
  />
</template>

<script>
export default {
  components: {
    SegmentsConfiguration: () => import('@/modules/mobile/sorteio/views/components/SegmentsConfiguration.vue'),
  },
  props: {
    segments: Array,
    error: Boolean,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    segmentsLocal: {
      get() {
        return this.segments
      },
      set(value) {
        this.$emit('update:segments', value)
      },
    },
    infoContent() {
      return '<span style="color: #004D99">Os segmentos são <b>atualizados diariamente</b>. Clientes que <b>atualmente estão no segmento</b> não terão números da sorte gerados e não serão capazes de visualizar o sorteio no app.</span>'
    },
    description() {
      return 'Selecione os segmentos que serão excluídos do sorteio.'
    },
    title() {
      return 'Excluir público-alvo'
    },
  },
}
</script>
